/** The installed app supplies a handler that keeps links inside its own UI. */
export class AppNavigation {
  private static handler: (url: string) => void;
  static registerNativeHandler(handler: (url: string) => void): void { this.handler = handler; }
  static open(url: string): void {
    if (this.handler) this.handler(url);
    else window.open(url, "_blank");
  }
  static navigate(url: string): void {
    if (this.handler) this.handler(url);
    else window.location.href = url;
  }
}
